export default "__VITE_ASSET__C5zXVZ95__"